<template>
  <div>
    <Head class="noprint" title="របាយការណ៍យឺត" />
    <h1 class="moul flex items-center mb-2 text-2xl">
      <Link class="flex items-center" href="/reports"><PresentationChartLineIcon class="mr-2 w-8 h-8" /> របាយការណ៍យឺត៖ {{ formattedDate(this.date) }}</Link>
    </h1>
    <div class="noprint flex items-center justify-between">
      <div class="flex w-full">
        <select-input @change="handleSearch" v-model="form.officer_id" :error="form.errors.officer_id" class="pb-4 pr-6 w-full lg:w-1/4" label="មន្ត្រី​ឥណទាន *">
          <option :value="null">បង្ហាញទាំងអស់</option>
          <option v-for="user in users" :key="user.id" :value="user.id">{{ user.first_name }} {{ user.last_name }}</option>
        </select-input>
        <text-input @change="handleSearch" v-model="form.date" :error="form.errors.date" type="date" class="pb-4 pr-6 w-full lg:w-1/4" label="កាលបរិច្ឆេទ *" />
      </div>

      <button class="flex items-center mb-2 px-4 py-2 hover:text-indigo-500 text-white hover:bg-green-300 bg-green-500 rounded-md" tabindex="-1" type="button" @click="print"><PrinterIcon class="mr-1 w-5 h-5" />បោះពុម្ភ</button>
    </div>
    <div class="noprint flex flex-wrap justify-center">
      <div class="p-4 w-full md:w-1/2 lg:w-1/4">
        <div class="p-6 bg-white rounded-lg shadow-md">
          <h2 class="mb-4 text-xl font-semibold">អតិថិជនសរុប</h2>
          <p class="text-green-600 text-3xl font-bold">{{ this.total_customers }} <span class="text-sm">នាក់</span></p>
        </div>
      </div>
      <div class="p-4 w-full md:w-1/2 lg:w-1/4">
        <div class="p-6 bg-white rounded-lg shadow-md">
          <h2 class="mb-4 text-xl font-semibold">ប្រាក់ត្រូវប្រមូលសរុប</h2>
          <p class="text-indigo-600 text-3xl font-bold">{{ formatNumber(this.total_to_pay) }}</p>
        </div>
      </div>
      <div class="p-4 w-full md:w-1/2 lg:w-1/4">
        <div class="p-6 bg-white rounded-lg shadow-md">
          <h2 class="mb-4 text-xl font-semibold">ប្រាក់ដែលបានប្រមូល</h2>
          <p class="text-green-600 text-3xl font-bold">{{ formatNumber(this.total_paid_amount) }}</p>
        </div>
      </div>
      <div class="p-4 w-full md:w-1/2 lg:w-1/4">
        <div class="p-6 bg-white rounded-lg shadow-md">
          <h2 class="mb-4 text-xl font-semibold">ប្រាក់នៅសល់</h2>
          <p class="text-red-600 text-3xl font-bold">{{ formatNumber(this.total_amount_due) }}</p>
        </div>
      </div>
      <!-- Add more cards here as needed -->
    </div>
    <div class="schedule bg-white overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-medium">
          <!-- <td class=" text-center border border-black">ID កម្ចី</td> -->
          <td class="text-center border text-sm border-black">កាលបរិច្ឆេទបង់</td>
          <td class="text-center border text-sm border-black px-1">សប្តាហ៍</td>
          <td class="text-center border text-sm border-black">ឈ្មោះអតិថិជន</td>
          <td class="text-center border text-sm border-black">ទូរសព្ទ</td>
          <td class="text-center border text-sm border-black">អាសយដ្ឋាន</td>
          <td class="text-center border border-black text-sm">រយៈពេល</td>
          <td class="text-center border text-sm border-black">មន្ត្រីឥណទាន</td>
          <td class="text-center border text-sm border-black">ប្រាក់ដើមនៅសល់</td>
          <td class="text-center border text-sm border-black">ប្រាក់ដើមត្រូវសង</td>
          <td class="text-center border text-sm border-black">ការប្រាក់</td>
          <td class="py-1 text-center text-sm border border-black">សេវាប្រ/តិ<br />និងរដ្ឋបាល</td>
          <td class="py-1 text-center text-sm border border-black">យឺត</td>
          <td class="py-1 text-center text-sm border border-black noprint"></td>
          <td class="py-1 text-center text-sm border border-black">ពិន័យ</td>
          <td class="py-1 text-center text-sm text-indigo-600 border border-black">សរុប</td>
          <td class="py-1 text-center text-sm text-green-600 border border-black">បានបង់</td>
          <td class="py-1 text-center text-sm text-red-600 border border-black">នៅសល់</td>
          <td class="noprint py-1 text-sm text-center text-red-600 border border-black"></td>
        </tr>
        <tr v-for="(schedule, index) in schedules" :key="index" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <!-- <td class=" text-center border border-black">{{ schedule.loan.loan_id }}</td> -->
          <td style="min-width: 100px!important;white-space: break-spaces" class="text-center border px-1 text-sm border-black">{{ formattedDate(schedule.pay_date) }}</td>
          <!-- <td class=" text-center border border-black">{{ schedule.loan.borrower.customer_id }}</td> -->
          <td class="text-center text-sm border border-black">{{ schedule.order_number }}</td>
          <td class="text-center text-sm font-medium border border-black">
            {{ schedule.customer_fullname }}
          </td>
          <td style="min-width: 100px!important;white-space: break-spaces" class="text-center border text-sm border-black">{{ schedule.customer_phone?schedule.customer_phone:'' }}</td>
          <td style="min-width:100px; white-space: break-spaces" class="text-center text-xs border border-black">{{ schedule.customer_address }}</td>
          <td class="text-center border border-black text-sm">{{ schedule.term }}</td>
          <td class="text-center font-medium text-sm border border-black">{{ schedule.officer_fullname }}</td>
          <td class="text-center border text-sm border-black">{{ formatNumber(schedule.balance) }}</td>
          <td class="text-center border text-sm border-black">{{ formatNumber(schedule.principle_amount) }}</td>
          <td class="text-center border text-sm border-black">{{ formatNumber(schedule.interest) }}</td>
          <td class="text-center border text-sm border-black">{{ formatNumber(schedule.service_fee) }}</td>
          <td class="text-center border text-sm border-black">{{ schedule.late_days }}ថ្ងៃ</td>
          <td class="noprint text-center border text-sm border-black"><input type="checkbox" v-model="checkedItems[schedule.id]" @change="handleChange(index, $event)"/></td>
          <td class="text-center border text-sm border-black">{{ formatNumber(schedule.pay_penalty) }}</td>
          <td class="text-center text-indigo-600 text-sm font-medium border border-black">{{ formatNumber(schedule.amount_to_pay) }}</td>
          <td class="text-center text-green-600 text-sm font-medium border border-black">
            {{ formatNumber(schedule.paid_amount) }}
          </td>
          <td class="text-center text-red-600 font-medium border text-sm border-black">
            {{ formatNumber(schedule.amount_due) }}
          </td>
          <td class="noprint text-center font-medium border border-black">
            <loading-button v-if="schedule.paid_amount <= 0" :loading="schedule.loading ? true : false" class="text-white text-sm bg-green-500 rounded-md md:px-2" @click="handleClick(index, schedule.id)">បង់ប្រាក់</loading-button>
          </td>
        </tr>
        <tr v-if="schedules.length > 0" class="text-left font-medium">
          <td colspan="7" class="text-right text-red-600 border-b border-black">សរុបរួម</td>
          <td class="text-center text-sm bg-red-100 border border-black px-1">{{ formatNumber(this.total_balance) }}</td>
          <td class="text-center text-sm bg-red-100 border border-black px-1">{{ formatNumber(this.total_principle_amount) }}</td>
          <td class="text-center text-sm bg-red-100 border border-black px-1">{{ formatNumber(this.total_interest) }}</td>
          <td class="text-center text-sm bg-red-100 border border-black px-1">{{ formatNumber(this.total_service_fee) }}</td>
          <td class="text-center border border-black"></td>
          <td class="noprint text-center border border-black"></td>
          <td class="text-center text-sm bg-red-100 border border-black px-1">{{ formatNumber(this.total_pay_penalty) }}</td>
          <td class="text-center text-sm text-indigo-600 bg-red-100 border border-black px-1">{{ formatNumber(this.total_to_pay) }}</td>
          <td class="text-center text-sm text-green-600 bg-red-100 border border-black px-1">{{ formatNumber(this.total_paid_amount) }}</td>
          <td class="text-center text-sm text-red-600 bg-red-100 border border-black px-1">{{ formatNumber(this.total_amount_due) }}</td>
          <td class="noprint"></td>
        </tr>
        <tr v-if="schedules.length === 0">
          <td class="px-6 py-4 border-t" colspan="8">ពុំមានកម្ចីត្រូវបានបង្ហាញទេ!</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="schedules.links" />
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import { PresentationChartLineIcon, PrinterIcon } from '@heroicons/vue/24/outline'
import { formattedDate, formatNumber } from '@/helper'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import axios from 'axios'

export default {
  components: {
    Head,
    PresentationChartLineIcon,
    PrinterIcon,
    SelectInput,
    TextInput,
    LoadingButton,
  },
  layout: Layout,
  props: {
    schedules: Object,
    users: Object,
    date: Date,
    officer_id: String,
    total_customers: Number,
    total_balance: Number,
    total_principle_amount: Number,
    total_service_fee: Number,
    total_interest: Number,
    total_to_pay: Number,
    total_amount_due: Number,
    total_paid_amount: Number,
    total_pay_penalty: Number,
  },
  methods: {
    formattedDate,
    formatNumber,
    print() {
      var style = document.createElement('style')
      style.appendChild(document.createTextNode('@media print { @page { size: landscape; } html, body{margin:0!important; padding:0!important; font-size:11px!important;} }'))
      document.head.appendChild(style)
      window.print()
    },
    handleSearch() {
      this.officer_id = 1
      this.form.get('/reports/late')
    },
    handleClick(index, id) {
      this.schedules[index].loading = true
      axios
        .post('/reports/pay', {
          schedule_id: id,
        })
        .then((response) => {
          response.data.status == true ? location.reload() : null
        })
    },
    handleChange(index, event) {
      const isChecked = event.target.checked;
      const item = this.schedules[index].id;

      axios
        .post('/reports/set_penalty', {
          item: item,
          checked: isChecked
        })
        .then((response) => {
          response.data.status == true ? location.reload() : null
        })
    }
  },
  created() {
    // Initialize checkedItems based on schedule.is_penalty
    this.schedules.forEach(schedule => {
      this.checkedItems[schedule.id] = schedule.is_penalty?true:false;
    });
    
  },
  remember: 'form',
  data() {
    return {
      schedules: this.schedules,
      date: this.date,
      officer_id: this.officer_id,
      users: this.users,
      total_customers: this.total_customers,
      total_balance: this.total_balance,
      total_principle_amount: this.total_principle_amount,
      total_interest: this.total_interest,
      total_service_fee: this.total_service_fee,
      total_to_pay: this.total_to_pay,
      total_amount_due: this.total_amount_due,
      total_paid_amount: this.total_paid_amount,
      form: this.$inertia.form({
        officer_id: this.officer_id,
        date: this.date,
      }),
      checkedItems: []
    }
  },
}
</script>
